import { PizzaWheel } from "./PizzaWheel";
import "./index.css";

export function App() {
  return <PizzaWheel />;
}

export default App;
